/** The editor's Impact tab (#566) — after Changes. */
export const IMPACT_TAB = 10;

/** The last editor tab a `?tab=N` link may open: Impact. */
export function lastStudioTab(): number {
  return IMPACT_TAB;
}

/** `?tab=N` → the editor tab, or Overview for anything else. */
export function studioTabFromParam(tab?: string): number {
  if (!tab || !/^\d{1,2}$/.test(tab)) return 0;
  const n = Number(tab);
  return n <= lastStudioTab() ? n : 0;
}
